// extracted by mini-css-extract-plugin
export default {"root":"Tabs_root__QxtAS","heading":"Tabs_heading__wk3k3","required-fields-info":"Tabs_required-fields-info__cdwpr"};